import React, { useEffect, useMemo } from "react";
import { Typography, Input } from "antd";
import { useSurveyInputStore } from "../../../../surveyStore";
import useGetOrderedSurveys from "../../../../editor/logic-builder/hooks/useGetOrderedSurveys";
import { REGEX } from "../../../../../../../helpers/constraintParsers";
import useEvaluateConstraint from "../../question-preview/hooks/useEvaluateConstraint";
import Marked from "../../../../../../../shared/Marked";

import "./Note.scss";

export function Note({
   props,
   submissionId,
   surveyId,
   userId,
   label,
   hint,
   language,
   defaultValue
}) {
   const { answers } = props;

   const setInputs = useSurveyInputStore((state) => state.setInputs);
   const orderedSurveys = useGetOrderedSurveys();

   const jrChoiceNameMatch = props.calculation && props.calculation.match(REGEX.jrChoiceName);
   const hasChoiceNameRegex = jrChoiceNameMatch && jrChoiceNameMatch?.[0] !== "";

   const choiceNameOptions = useMemo(() => {
      if (!hasChoiceNameRegex) return [];
      if (!orderedSurveys?.surveyOrdered || !jrChoiceNameMatch?.[2]) return [];

      const searchName = jrChoiceNameMatch[2].replace(/\$|{|}/g, "");
      const surveyItem = orderedSurveys.surveyOrdered?.find((item) => {
         const matches = item.surveyItem?.name === searchName;
         return matches;
      });
      if (!surveyItem) return [];

      return surveyItem.surveyItem.selectQuestionChoices?.map((item) => {
         const translatedLabel = item.choiceLabels.find((label) => label.languageId === language)
            ?.text;
         const fallbackLabel = item.choiceLabels[0]?.text;

         return {
            label: translatedLabel || fallbackLabel,
            value: item.name
         };
      });
   }, [hasChoiceNameRegex, orderedSurveys, jrChoiceNameMatch, language]);

   const evaluateConstraint = useEvaluateConstraint(
      jrChoiceNameMatch?.[0],
      true,
      choiceNameOptions
   );

   const hasSubmissionId = Boolean(submissionId);

   const submissionAnswer = useMemo(
      () =>
         answers?.find((answer) =>
            props.repeatInstanceIndex
               ? answer?.answerDetail.repeatGroup === props.repeatInstanceIndex
               : answer
         )?.answerDetail?.text,
      [answers, props.repeatInstanceIndex]
   );
   const value = hasSubmissionId
      ? submissionAnswer
      : evaluateConstraint ?? props.default ?? defaultValue;

   useEffect(() => {
      if (!value) {
         return;
      }
      setInputs({
         target: {
            name: props.id,
            value: {
               surveyId: surveyId,
               userId: userId,
               questionId: props.id,
               questionType: props.questionType,
               name: props.name,
               skipLogicAnswer: value,
               answerDetail: {
                  text: value
               }
            }
         }
      });
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [value]);

   return (
      <div className="note-submission-type-wrapper">
         <Typography.Paragraph className="note-submission-type-wrapper--note_text">
            <Marked className="marked">{label}</Marked>
         </Typography.Paragraph>
         {hint && <span className="note-submission-type-wrapper--hint">{hint}</span>}
         {(props.calculation || props.default) && (
            <Input
               prefixCls="note-submission-type-wrapper--read_only_input"
               size="large"
               value={value}
               readOnly
            />
         )}
      </div>
   );
}
